import { createSlice } from '@reduxjs/toolkit'

export interface ITourViewState {
    addNewTourModal: boolean
    editTourEndpointModal: boolean
    editTourData: any
}

const initialState: ITourViewState = {
    addNewTourModal: false,
    editTourEndpointModal: false,
    editTourData: null
}

const tourViewSlice = createSlice({
    name: 'tour/view',
    initialState,
    reducers: {
        setAddNewTourModal(state, action) {
            state.addNewTourModal = action.payload.visible
        },
        setEditTourEndpointModal(state, action) {
            state.editTourEndpointModal = action.payload.visible
            state.editTourData = action.payload.tourData
        }
    }
})

export const tourViewActions = tourViewSlice.actions
export default tourViewSlice.reducer
